<div>
  <main>
    <section class="relative w-full h-full py-40 min-h-screen">
      <div
        class="absolute top-0 w-full h-full bg-blueGray-800 bg-no-repeat bg-cover"
      ></div>
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
